import React, { useState } from 'react';
import Header from './components/Header';
import FavoritesSection from './components/FavoritesSection';
import NewsCarousel from './components/NewsCarousel';
import BalanceCard from './components/BalanceCard';
import ExpedienteCard from './components/ExpedienteCard';
import ServicesGrid from './components/ServicesGrid';
import LoadingOverlay from './components/LoadingOverlay';
import RegistrationPage from './components/RegistrationPage';
import GradesPage from './components/GradesPage';
import LoginPage from './components/LoginPage';

const studentServices = [
  { id: '1', title: 'Autoservicios de Banner', icon: 'banner', color: 'blue' },
  { id: '2', title: 'Mis Calificaciones', icon: 'grades', color: 'blue' },
  { id: '3', title: 'Calificaciones de ciclos anteriores', icon: 'history', color: 'blue' },
  { id: '4', title: 'Eventos TecMilenio', icon: 'events', color: 'purple' },
];

const adminServices = [
  { id: '5', title: 'Portal de Autoservicios', icon: 'servicenow', color: 'teal' },
  { id: '6', title: 'Facturación', icon: 'billing', color: 'blue' },
  { id: '7', title: 'Tienda Virtual', icon: 'store', color: 'teal' },
  { id: '8', title: 'Estado de Cuenta', icon: 'account', color: 'purple' },
];

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState<'main' | 'registration' | 'grades'>('main');
  const [selectedGradesTerm, setSelectedGradesTerm] = useState('EC ABRIL 2026 (View only)');

  const handleLogin = async () => {
    setIsLoading(true);
    // Simulate 5-second login process
    setTimeout(() => {
      setIsAuthenticated(true);
      setIsLoading(false);
    }, 5000);
  };

  const handleClick = () => {
    setIsLoading(true);
    // Keep loading indefinitely for general clicks
  };

  const handleServiceClick = async (serviceId: string) => {
    if (serviceId === '3') { // calificaciones de ciclos anteriores (antes del ciclo Abr. 2026)
      setIsLoading(true);
      // 5-second delay before navigating to registration
      setTimeout(() => {
        setCurrentPage('registration');
        setIsLoading(false);
      }, 5000);
    } else {
      setIsLoading(true);
      // Keep loading indefinitely for other services
    }
  };

  const handleAdminServiceClick = (serviceId: string) => {
    setIsLoading(true);
    // Keep loading indefinitely for admin services
  };

  const handleBackToMain = async () => {
    setIsLoading(true);
    // 5-second delay before going back to main
    setTimeout(() => {
      setCurrentPage('main');
      setIsLoading(false);
    }, 5000);
  };

  const handleSelectAnotherTerm = async () => {
    setIsLoading(true);
    // 5-second delay before going to registration
    setTimeout(() => {
      setCurrentPage('registration');
      setIsLoading(false);
    }, 5000);
  };

  const handleTermSelection = async (term: string) => {
    setIsLoading(true);
    if (term === 'EC ABRIL 2026 (View only)' || term === 'EC SEPTIEMBRE 2025 (View only)') {
      // 5-second delay before showing grades
      setTimeout(() => {
        setSelectedGradesTerm(term);
        setCurrentPage('grades');
        setIsLoading(false);
      }, 5000);
    } else {
      // Keep loading indefinitely for other terms
    }
  };

  // Show login page if not authenticated
  if (!isAuthenticated) {
    return (
      <>
        <LoginPage onLogin={handleLogin} />
        {isLoading && <LoadingOverlay />}
      </>
    );
  }

  if (currentPage === 'registration') {
    return (
      <>
        <RegistrationPage onBack={handleBackToMain} onSelectTerm={handleTermSelection} />
        {isLoading && <LoadingOverlay />}
      </>
    );
  }

  if (currentPage === 'grades') {
    return (
      <>
        <GradesPage onBack={handleBackToMain} onSelectAnotherTerm={handleSelectAnotherTerm} term={selectedGradesTerm} />
        {isLoading && <LoadingOverlay />}
      </>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <FavoritesSection onButtonClick={handleClick} />
      <NewsCarousel />
      
      {/* Dashboard Cards */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <BalanceCard onButtonClick={handleClick} />
            <ExpedienteCard />
          </div>
        </div>
      </section>

      <ServicesGrid 
        title="Alumnos"
        subtitle="En esta sección podrás encontrar todo lo relacionado a tus calificaciones, actividades y más"
        services={studentServices}
        onServiceClick={handleServiceClick}
      />

      <ServicesGrid 
        title="Administrativo"
        subtitle="Aquí podrás encontrar todo lo relacionado a pagos y seguros"
        services={adminServices}
        onServiceClick={handleAdminServiceClick}
      />

      {/* Chat bot indicator */}
      <div className="fixed bottom-6 right-6">
        <div 
          className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center text-white cursor-pointer hover:bg-teal-700 transition-colors shadow-lg"
          onClick={handleClick}
        >
          <span className="text-lg">💬</span>
        </div>
      </div>

      {/* Loading Overlay */}
      {isLoading && <LoadingOverlay />}
    </div>
  );
}

export default App;
